export default class CountriesService {
  constructor($http, host, notify) {
    this.$http = $http;
    this.host = host;
    this.notify = notify;
  }

  getCountries() {
    return this.$http({
      method: 'GET',
      url: this.host + '/api/countries'
    }).then(
      (resp) => { return resp.data.countries; },
      (resp) => {
        this.notify.error({
          message: "Ha ocurrido un error en la comunicación con nuestros servidores, intente nuevamente."
        });
        return resp.data;
      }
    );
  }
}

 CountriesService.$inject = ['$http', 'host', 'Notification'];



// WEBPACK FOOTER //
// ./src/app/services/countries.service.js